import { ReactNode } from "react"

type HeadingProps = {
    headline: string,
    weight: number,
    icon?: ReactNode,
    centered? :boolean
}

export const Heading = ({ headline, weight, icon, centered }: HeadingProps) => {
    return (
        <div className={"headline " + (centered ? "centered" : "")}>
        {{
                1: <h1 className='headline1' > {icon} {headline}</h1>,
                2: <h2 className='headline2' > {icon} {headline}</h2>,
                3: <h3 className='headline3' > {icon} {headline}</h3>,
                4: <h4 className='headline4' > {icon} {headline}</h4>
        }[weight]
        }
    </div>
    )
}